import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import QRCode from 'react-qr-code';
import Typography from '../../../core/ui/typography';
import Context from '../../../../utils/context';
import PostSurveyThankYou from '../../post_survey_thank_you/index_gated.jsx';

import thankYouStyles from '../../post_survey_thank_you/v2.module.css';

export default function BylvayThankYou({ conversationSurvey }) {
  const context = useContext(Context);
  const homePath = context.auth.isLoggedIn() ? '/member/conversations' : '/member/login';

  if (conversationSurvey?.data?.interested_in_mentoring !== "yes, i'd like to learn more") {
    return <PostSurveyThankYou conversationSurvey={conversationSurvey} />;
  }

  return (
    <div className={thankYouStyles.container}>
      <div className={thankYouStyles.content}>
        <div className={thankYouStyles.icon}>
          <span className={thankYouStyles.icon_glow} aria-hidden='true' />
          <span className={thankYouStyles.icon_circle}>
            <svg className={thankYouStyles.icon_check} viewBox='0 0 24 24' fill='none' aria-hidden='true'>
              <path
                d='M20 6 9 17l-5-5'
                stroke='#ffffff'
                strokeWidth='2.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </span>
        </div>
        <Typography as='h1' variant='heading4xl' align='center' className={thankYouStyles.title}>
          Thank You for Your Interest in Supporting Others!
        </Typography>
        <Typography variant='bodyLg' align='center' color='var(--text-secondary)' className={thankYouStyles.message}>
          Your willingness to share your experience can make a meaningful difference for families navigating this
          condition.
        </Typography>
        <Typography
          variant='uiSm'
          align='center'
          color='var(--text-tertiary)'
          className={thankYouStyles.caption}
          style={{ fontFamily: 'var(--font-body)' }}
        >
          To learn more about becoming a PatientPartner Mentor, scan the QR code below or{' '}
          <a href='mailto:patient.ambassador@ipsen.com' style={{ color: 'var(--primary-teal-600)' }}>
            click this link
          </a>
          .
        </Typography>
        <div style={{ margin: 'var(--space-2) 0' }}>
          <QRCode value='mailto:patient.ambassador@ipsen.com' size={180} />
        </div>
        <Link to={homePath} className={thankYouStyles.home_link}>
          <button type='button' className={thankYouStyles.home_button}>
            Home
          </button>
        </Link>
      </div>
    </div>
  );
}
